import * as Yup from 'yup'

import {
  acceptConditions,
  commune,
  radioGroup,
  street,
  streetNumber,
  towerApartmentHouse,
} from '../../utils/yup'

export const PAYMENT_SCHEMA_SUBSCRIPTION = Yup.object().shape({
  radioGroup,
  acceptConditions,
})

export const BILLING_INFORMATION_SCHEMA = Yup.object().shape({
  street,
  streetNumber,
  towerApartmentHouse,
  commune,
})
